import { opsDict, scmDict } from '@/hooks/dictionary';
import type { ICategoryListReq } from '@/api/product/types';
import { IdictValuesItem } from '@/api/dict/types';

export type IdictValuesItemNode = IdictValuesItem & { children?: IdictValuesItemNode[]; }
export interface NodeMap {
  [propName: string]: IdictValuesItemNode;
}
/**
 * 获取 dictCode 扁平数组 => treeList
 * @param batchDictListMap use-dict 返回的字典集合
 * @param categoryCode dictCode
 * @returns
 */

/* OPS 级联数据 */
export const useOpsCascader = (code: string = '', maxLayer?: number) => {
  return opsDict.getCascader({
    code,
    maxLayer,
  });
};

/* 尺码标准 + 尺码 */
export const useClothesSize = (maxLayer?: number) => {
  return opsDict.getCascader({
    code: 'plm_standard_size',
    comma: true,
    maxLayer,
  });
};

/**
 * 获取 商品库 辅料 、工艺 级联选项
 * @param type
 * @returns
 */
export const useProductCascader = (type: ICategoryListReq) => {
  return scmDict.getCascader({
    code: type,
  });
};
